import React from "react";
import { Box } from "@mui/material";
import { adminSectionSeparatorSx } from "../shared/styles";

function AdminSectionSeparator() {
  return <Box sx={adminSectionSeparatorSx} />;
}

export default AdminSectionSeparator;
